import { render, staticRenderFns } from "./open-indicator.vue?vue&type=template&id=3e83177a&"
import script from "./open-indicator.vue?vue&type=script&lang=js&"
export * from "./open-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports